import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import { PARTNER_PORTAL_DASHBOARD_FEATURES } from '../../constants/Pages/PartnerWithUs';

import './PartnerPortalDashboard.css';

export const PartnerPortalDashboard = ({ PartnerHub_Dashboard }) => {
  const [expandedSections, setExpandedSections] = useState({});
  return (
    <div className="partner-portal-dashboard-container">
      <div>
        <div className="partner-portal-dashboard-header">{PARTNER_PORTAL_DASHBOARD_FEATURES}</div>

        {Object.keys(PartnerHub_Dashboard).map((feature) => {
          return (
            <Accordion
              sx={{
                '&:first-of-type': {
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                },
                '&:last-of-type': {
                  borderBottomLeftRadius: '10px',
                  borderBottomRightRadius: '10px',
                },
                '&.Mui-expanded': {
                  margin: '0 auto',
                  marginBottom: '20px',
                },
                border: '1px solid black',
                p: '1.25rem',
                p: { xs: '.5rem', sm: '0.5rem' },
                width: { sm: '80%' },
                margin: '0 auto',
                marginBottom: '20px',
                borderRadius: '10px',
              }}
              expanded={expandedSections[feature]}
              onChange={() => {
                setExpandedSections((prevState) => {
                  const updatedObj = {
                    ...prevState,
                    [feature]: !expandedSections[feature],
                  };

                  mixpanel.track('Dashboard Features', {
                    dashboardFeature: feature,
                    expandedSections: updatedObj,
                  });

                  return updatedObj;
                });
              }}
              key={feature}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                className="partner-portal-section-header"
                sx={{
                  '&.Mui-expanded': {
                    minHeight: '50px',
                  },
                  fontSize: '16px',
                }}
              >
                {feature}
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  padding: '8px 16px',
                }}
              >
                <div className="partner-portal-dashboard-row-description-wrapper">
                  {PartnerHub_Dashboard[feature].map((info) => {
                    if (typeof info === 'object') {
                      return (
                        <>
                          <li className="partner-portal-dashboard-row-feature-title">
                            {info.TEXT}
                          </li>
                          {info.LIST.map((item) => {
                            return (
                              <li className="partner-portal-dashboard-row-feature-list-item">
                                {item}
                              </li>
                            );
                          })}
                        </>
                      );
                    }

                    return <li className="partner-portal-dashboard-row-feature-title"> {info} </li>;
                  })}
                </div>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};
